__turbopack_context__.v({
  "audio": "MediaPlayer-module-scss-module__fNJA8a__audio",
  "overlay": "MediaPlayer-module-scss-module__fNJA8a__overlay",
  "paused": "MediaPlayer-module-scss-module__fNJA8a__paused",
  "player": "MediaPlayer-module-scss-module__fNJA8a__player",
  "playing": "MediaPlayer-module-scss-module__fNJA8a__playing",
  "stopped": "MediaPlayer-module-scss-module__fNJA8a__stopped",
});
